import { jsx, jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from "react";
import { DataTable } from "@teselagen/ui";
import { CutsiteTag } from "../../CutsiteFilter/AdditionalCutsiteInfoDialog";
import EnzymeViewer from "../../EnzymeViewer";
import { getEnzymeAliases } from "../../utils/editorUtils";
const schema = {
  fields: [
    { path: "topSnipPosition", displayName: "Top Snip", type: "string" },
    { path: "position", type: "string" },
    { path: "strand", type: "string" }
  ]
};
export default function SingleEnzymeCutsiteInfo({
  cutsiteGroup,
  enzyme,
  dispatch,
  allRestrictionEnzymes,
  editorName,
  selectedAnnotationId,
  allCutsites,
  filteredCutsites: { cutsitesByName: cutsitesByNameActive }
}) {
  const onRowSelect = useCallback(
    ([record]) => {
      if (!record) return;
      dispatch({
        type: "CARET_POSITION_UPDATE",
        payload: record.topSnipPosition,
        meta: {
          editorName
        }
      });
    },
    [dispatch, editorName]
  );
  const aliases = useMemo(() => getEnzymeAliases(enzyme), [enzyme]);
  const entities = useMemo(
    () => cutsiteGroup.sort((a, b) => a.topSnipPosition - b.topSnipPosition).map(
      ({
        restrictionEnzyme: { forwardRegex, reverseRegex } = {},
        forward,
        id,
        topSnipBeforeBottom,
        topSnipPosition,
        bottomSnipPosition
      }) => {
        return {
          id,
          topSnipPosition,
          position: topSnipBeforeBottom ? topSnipPosition + " - " + bottomSnipPosition : bottomSnipPosition + " - " + topSnipPosition,
          strand: forwardRegex === reverseRegex ? "Palindromic" : forward ? "1" : "-1"
        };
      }
    ),
    [cutsiteGroup]
  );
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: "ve-enzymeSubrow",
      style: {
        margin: 10
      },
      children: [
        enzyme && /* @__PURE__ */ jsx(
          EnzymeViewer,
          {
            sequence: enzyme.site,
            reverseSnipPosition: enzyme.bottomSnipOffset,
            forwardSnipPosition: enzyme.topSnipOffset
          }
        ),
        /* @__PURE__ */ jsx("br", {}),
        entities && !!entities.length && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          DataTable,
          {
            style: { minHeight: 0, maxHeight: 200 },
            selectedIds: selectedAnnotationId,
            maxHeight: 300,
            onRowSelect,
            formName: "cutLocations",
            isSingleSelect: true,
            compact: true,
            noRouter: true,
            minimalStyle: true,
            scrollToSelectedRowRelativeToDom: true,
            noHeader: true,
            isSimple: true,
            noFullscreenButton: true,
            isInfinite: true,
            withSearch: false,
            withFilter: false,
            schema,
            entities
          }
        ) }),
        aliases && aliases.length && /* @__PURE__ */ jsxs("div", { style: { marginTop: 10 }, children: [
          "Aliases:",
          /* @__PURE__ */ jsx("div", { style: { display: "flex", flexWrap: "wrap" }, children: aliases.map((n, i) => {
            return /* @__PURE__ */ jsx(
              CutsiteTag,
              {
                allRestrictionEnzymes,
                cutsitesByNameActive,
                cutsitesByName: allCutsites.cutsitesByName,
                name: n,
                doNotShowCuts: true
              },
              i
            );
          }) })
        ] })
      ]
    }
  ) });
}
